import React, { useEffect } from "react";
import ActionModal from "../../components/home/create/ScriptModals/actionModal";
import MagicModal from "../../components/home/create/ScriptModals/magicModal";
import PostModal from "../../components/home/create/ScriptModals/postModal";
import InstructionModal from "../../components/home/create/ScriptModals/instructionModal";
import StatsModal from "../../components/home/create/ScriptModals/statsModal";

const ScriptModals = ({ modals, handleClose }) => {
  useEffect(() => {
    console.log("sm", modals);
  }, [modals]);
  return (
    <>
      <ActionModal show={modals.modelAction} handleClose={handleClose} />
      <MagicModal show={modals.modalMagic} handleClose={handleClose} />
      <PostModal show={modals.modalInstruction} handleClose={handleClose} />
      <InstructionModal show={modals.modalPost} handleClose={handleClose} />
      <StatsModal show={modals.modalStats} handleClose={handleClose} />
    </>
  );
};

export default ScriptModals;
